import { Modal } from "react-bootstrap";
import ModifierComboGroupContainer from "./ModifierComboGroupContainer.js";
import ErrorAlert from "../../../../common/ui/ErrorAlert.js";
import * as CommonUtilities from "../../../../common/utils/CommonUtils";

export default function ModifierComboGroupsListModalPage(props) {
    // Returns the modal page that contains the groups / selection within the selected Modifier Combo
    
    // Combo Pricing 
    let comboPriceNum = parseFloat(props.modifierComboGroupFormData.modComboPriceInc);
    let groupPricesNum = 0;
    props.modifierComboGroupFormData.modComboGroups.forEach((group) => {
        if (group.PriceInc === undefined) {
            groupPricesNum += parseFloat(0);
        } else {
            groupPricesNum += parseFloat(group.PriceInc);
        }
    });
    let totalPriceNum = comboPriceNum + groupPricesNum;
    let totalPriceToDisplay = CommonUtilities.formatDisplayPrice(totalPriceNum);

    // Groups
    let modifierComboGroups;
    if (props.modifierComboDetails.modifierComboDetails.modComboGroups.length > 0) {
        let modComboGroupIndex = -1;
        modifierComboGroups = props.modifierComboDetails.modifierComboDetails.modComboGroups.map((item, index) => {
            modComboGroupIndex += 1;
            return (
                <ModifierComboGroupContainer 
                    key={modComboGroupIndex}
                    modComboGroupIndex={modComboGroupIndex}
                    modComboGroupFormData={props.modifierComboGroupFormData.modComboGroups[index]}
                    modifierComboGroupDetails={item} // Passing just the specific group in the modifier combo
                    handleModifierComboGroupSelect={props.handleModifierComboGroupSelect}
                />
            )
        })
    } else {
        modifierComboGroups = <></>
    }

    return (
        <>
            <Modal.Body>
                <div className="row">
                    <div className="col-12 text-break">
                        <div>
                            <b className="me-2">{props.modifierComboDetails.modifierComboDetails.modLinkedToCombo.modName}</b>
                        </div>
                        {props.modifierComboDetails.modifierComboDetails.modCategoryDescription && <span>{props.modifierComboDetails.modifierComboDetails.modCategoryDescription}</span>}
                        <div className="mt-3 fw-bold">{totalPriceToDisplay}</div>
                    </div>
                    {modifierComboGroups}
                </div>
            </Modal.Body>
            <Modal.Footer>
                { props.errorModifierCombo.GroupsListPage.HasError && <div className="px-1 mx-auto mb-3 col-12"><ErrorAlert message={props.errorModifierCombo.GroupsListPage.ErrorMessage} /></div> }
                { props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber &&
                     <div className="col-12 d-flex justify-content-center mx-auto">
                        <button type="button" className="btn btn-dark rounded-pill px-5" onClick={props.handleModComboAddComboToProduct} disabled={props.errorModifierCombo.GroupsListPage.ButtonsDisabled}>
                            Add combo to product
                            { props.errorModifierCombo.GroupsListPage.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></> }
                        </button>
                     </div>
                }
            </Modal.Footer>
        </>
    )
}